module.exports = __webpack_public_path__ + "img/World map Icon - white.215de773.svg";